import RestModel from "discourse/models/rest";

export default class TagNotification extends RestModel {
  primaryKey = "name";
}
